import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getUmpire } from '@/services/supabaseService';
import { Umpire } from '@/integrations/supabase/types';
import UmpireProfileHeader from '../../components/umpire/UmpireProfileHeader';
import UmpireTabs from '../../components/umpire/UmpireTabs';

const UmpireProfilePage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [umpire, setUmpire] = useState<Umpire | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;
    getUmpire(id)
      .then((data) => {
        setUmpire(data);
        setLoading(false);
      })
      .catch(() => {
        setError('Failed to load umpire');
        setLoading(false);
      });
  }, [id]);

  if (loading) return <div className="py-12 text-center">Loading...</div>;
  if (error) return <div className="text-red-600 py-12 text-center">{error}</div>;
  if (!umpire) return <div className="py-12 text-center">Umpire not found</div>;

  return (
    <div className="max-w-5xl mx-auto py-8 animate-fade-in">
      <div className="rounded-2xl shadow bg-white overflow-hidden">
        <UmpireProfileHeader umpire={umpire} />
        <div className="px-8 pb-8">
          <UmpireTabs umpire={umpire} />
        </div>
      </div>
    </div>
  );
};

export default UmpireProfilePage; 